import { useEffect, useRef } from 'react';

/**
 * Run effect once ASAP when it isReady()
 * @param {Function} cb
 * @param {Array} [deps]
 * @param {Function} [isReady] - predicate to indicate when we are ready to run the effect
 */
export const useEffectOnce = (cb, deps, isReady = () => true) => {
    const didRun = useRef(false);
    const result = useRef();

    useEffect(() => {
        if (!didRun.current && isReady()) {
            didRun.current = true;
            result.current = cb();
        }

        return result.current;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
